import { z } from "zod";

export const ExporterWorkspaceMembershipRole = z.enum(["Owner", "OwnerArchived", "User"]);
export type ExporterWorkspaceMembershipRole = z.infer<typeof ExporterWorkspaceMembershipRole>;
